import { useSelector } from 'react-redux'

import { getRecommendationId } from 'selectors/menu-metadata/getRecommendationId'

export const useMenuMeta = () => {
  const recommendationId = useSelector(getRecommendationId)

  return {
    recommendationId,
  }
}
